export const GET_USER_AGREEMENTS = "GET_USER_AGREEMENTS"
export const GET_USER_AGREEMENTS_SUCCESS = "GET_USER_AGREEMENTS_SUCCESS"
export const GET_USER_AGREEMENTS_FAIL = "GET_USER_AGREEMENTS_FAIL"


export const USER_AGREEMENTS_API_ERROR = "USER_AGREEMENTS_API_ERROR"
